import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { formatCount } from "@/mocks/articles";

const tabs = [
  { key: "24h", label: "24小时" },
  { key: "7d", label: "近7天" },
  { key: "heat", label: "热度" },
];

export default function HotRank() {
  const [active, setActive] = useState("24h");

  const list = useMemo(() => {
    const sorted = [...articles].sort((a, b) => b.heat - a.heat);
    if (active === "24h") return sorted.slice(0, 6);
    if (active === "7d") return [...sorted.slice(3), ...sorted.slice(0, 3)].slice(0, 6);
    return [...sorted].sort((a, b) => b.views - a.views).slice(0, 6);
  }, [active]);

  const rankColor = (i: number) =>
    i === 0 ? "text-primary-500" : i === 1 ? "text-secondary-500" : i === 2 ? "text-accent-600" : "text-background-400";

  return (
    <section className="flex h-full flex-col rounded-2xl border border-background-200/70 bg-background-100/50 p-4 md:p-5" aria-label="实时热榜">
      <div className="flex items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 font-heading text-lg font-black text-foreground-950">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-base" aria-hidden="true"></i>
          </span>
          实时热榜
        </h2>
        <Link to="/hot" className="inline-flex items-center gap-1 text-xs font-medium text-primary-700 hover:text-primary-600">
          全部热点 <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="mt-3 flex items-center gap-1 rounded-full bg-background-200/70 p-1">
        {tabs.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setActive(t.key)}
            className={`flex-1 whitespace-nowrap rounded-full px-2 py-1.5 text-xs font-medium transition-colors cursor-pointer ${
              active === t.key ? "bg-foreground-950 text-background-50" : "text-foreground-700 hover:text-foreground-950"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <ol className="mt-3 flex flex-1 flex-col">
        {list.map((a, i) => (
          <li key={a.slug}>
            <Link
              to={`/article/${a.slug}`}
              className="group flex items-start gap-3 rounded-lg px-1 py-2.5 transition-colors hover:bg-background-50"
            >
              <span className={`w-6 shrink-0 text-center font-heading text-xl font-black leading-7 ${rankColor(i)}`}>
                {i + 1}
              </span>
              <span className="flex min-w-0 flex-1 flex-col">
                <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-950 group-hover:text-primary-700">
                  {a.title}
                </span>
                <span className="mt-1 flex items-center gap-2 text-xs text-foreground-600">
                  <span className="rounded bg-primary-100 px-1.5 py-0.5 text-primary-700">{a.catName}</span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-fire-line text-secondary-500" aria-hidden="true"></i>
                    {a.heat}° 热
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line" aria-hidden="true"></i>
                    {formatCount(a.views)}
                  </span>
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
}